<div [@routerTransition]>
    <sub-header [title]="'Companies' | localize" [description]="'CompaniesHeaderInfo' | localize">
        <div role="actions">
            <button
                id="btn_create_company"
                *ngIf="'Pages.Companies.Create' | permission"
                (click)="createCompany()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewCompany') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input
                                            [(ngModel)]="filterText"
                                            (ngModelChange)="getCompanies()"
                                            name="filterText"
                                            autoFocus
                                            type="text"
                                            class="form-control"
                                            [placeholder]="l('SearchWithThreeDot')"
                                        />
                                        <button class="btn btn-primary" type="submit" (click)="getCompanies()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getCompanies($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            tableStyleClass="table table-bordered table-hover"
                            [lazy]="true"
                            [scrollable]="true"
                            ScrollWidth="100%"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th
                                        style="width: 50px"
                                        [hidden]="!isGrantedAny('Pages.Companies.Edit', 'Pages.Companies.Delete')">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 100px" pSortableColumn="code">
                                        {{ l('Code') }}
                                        <p-sortIcon field="company.code"></p-sortIcon>
                                    </th>
                                    <th style="width: 350px" pSortableColumn="name">
                                        {{ l('Name') }}
                                        <p-sortIcon field="company.name"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="address1">
                                        {{ l('Address1') }}
                                        <p-sortIcon field="company.address1"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="state">
                                        {{ l('State') }}
                                        <p-sortIcon field="company.state"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="country">
                                        {{ l('Country') }}
                                        <p-sortIcon field="company.country"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="postalCode">
                                        {{ l('PostalCode') }}
                                        <p-sortIcon field="company.postalCode"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="phoneNumber">
                                        {{ l('PhoneNumber') }}
                                        <p-sortIcon field="company.phoneNumber"></p-sortIcon>
                                    </th>
                                    <!-- <th style="width: 150px" pSortableColumn="imagePath">
                                        {{ l('ImagePath') }}
                                        <p-sortIcon field="company.imagePath"></p-sortIcon>
                                    </th> -->
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td
                                        style="width: 50px"
                                        [hidden]="!isGrantedAny('Pages.Companies.Edit', 'Pages.Companies.Delete')"
                                    >
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a
                                                        *ngIf="permission.isGranted('Pages.Companies.Edit')"
                                                        class="dropdown-item"
                                                        [routerLink]="['/app/master/companies/createOrEdit']"
                                                        [queryParams]="{ id: record.company.id }"
                                                    >
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        class="dropdown-item"
                                                        href="javascript:;"
                                                        *ngIf="permission.isGranted('Pages.Companies.Delete')"
                                                        (click)="deleteCompany(record.company)"
                                                    >
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 100px">
                                        <span class="p-column-title">{{ l('Code') }}</span>
                                        {{ record.company.code }}
                                    </td>
                                    <td style="width: 350px">
                                        <span class="p-column-title">{{ l('Name') }}</span>
                                        {{ record.company.name }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Address1') }}</span>
                                        {{ record.company.address1 }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('State') }}</span>
                                        {{ record.company.state }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Country') }}</span>
                                        {{ record.company.country }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('PostalCode') }}</span>
                                        {{ record.company.postalCode }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('PhoneNumber') }}</span>
                                        {{ record.company.phoneNumber }}
                                    </td>
                                    <!-- <td style="width: 150px">
                                        <span class="p-column-title">{{ l('ImagePath') }}</span>
                                        {{ record.company.imagePath }}
                                    </td> -->
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getCompanies($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal
        (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal
    ></excel-column-selection-modal>
</div>
